import { BlockStack, RadioButton, Box } from "@shopify/polaris";
import { useCallback } from "react";

interface DuplicatesProps {
  value: string;
  update: (value: string) => void;
}

/**
 * @param {Object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.update
 */
export function Duplicates({ value, update }: DuplicatesProps) {
  /**
   * @param {any} _
   * @param {string} newValue
   */
  const handleChange = useCallback((_: unknown, newValue: string) => update(newValue), [update]);

  return (
    <BlockStack gap="400">
      <RadioButton
        label="Standard"
        helpText="If Phone Number or Shipping Address matches a customer profile that has already redeemed this discount offer, we will block the discount code."
        checked={value === "standard"}
        id="standard"
        name="accounts"
        onChange={handleChange}
      />
      <RadioButton
        label="Phone Number Only"
        helpText="If Phone Number matches a customer profile that has already redeemed this discount offer, we will block the discount code."
        id="phonenumber"
        name="phonenumber"
        checked={value === "phonenumber"}
        onChange={handleChange}
      />
      <RadioButton
        label="Shipping Address Only"
        helpText="If Shipping Address matches a customer profile that has already redeemed this discount offer, we will block the discount code."
        id="shippingaddress"
        name="shippingaddress"
        checked={value === "shippingaddress"}
        onChange={handleChange}
      />
      <RadioButton label="Disabled" checked={value === "disabled"} id="disabled" name="accounts" onChange={handleChange} />
      
      <Box paddingBlock="400">
        <div style={{ borderTop: '1px solid #E1E3E5' }}></div>
      </Box>
      
      <RadioButton
        label="Tracking Only"
        helpText="Tracking only mode without any actual discount code blocks (we don't reject the discount - only observe we would've blocked it). Tracking mode uses the Standard setting logic (phone number OR shipping address both)."
        id="trackingonly"
        name="trackingonly"
        checked={value === "trackingonly"}
        onChange={handleChange}
      />
    </BlockStack>
  );
}
